import { Copy } from "lucide-react";
import { toast } from "sonner";

const SIGNATURE = `Best,
Alchemist (CA)
+1 647-887-0392
Instagram: https://www.instagram.com/dj__alchemist
SoundCloud (private playlist): [private playlist link]
Spotify: https://open.spotify.com/artist/06NV3L7olz3ocY4pe5GUFZ
Beatport: https://www.beatport.com/artist/alchemist-ca/1045911
EPK: https://www.dropbox.com/scl/fo/kn0dbcc1iaxp9xoke9msw/ACB0rwfJLySeCwoR1t2LRHo?rlkey=xmtgyjdtq9pkcuh35va4gmd7l&st=wnavrse9&dl=0
www.dj-alchemist.com`;

export function buildPlaylistNote(contact, tracks) {
  const picked = (contact.trackPack || []).map((id) => tracks.find((t) => t.id === id)).filter(Boolean);
  const list = picked.map((t, i) => `${i + 1}. ${t.title} — ${t.pitch}`).join("\n");
  const fit = contact.fitSentence || `${contact.company}'s direction`;
  const name = contact.targetName.includes(" ") && !/team|a&r|agency|delegates|records|music/i.test(contact.targetName) ? contact.targetName.split(" ")[0] : `${contact.company} team`;
  return `Subject: Great meeting you at ADE — Alchemist (CA), private music as promised

Hi ${name},

Really good to meet you at [location / event] on [day] — thanks for taking the time between everything happening at ADE. I enjoyed our chat about [specific thing they said].

As promised, here's a short private playlist with the ${picked.length || "2–3"} tracks I think sit most naturally in the lane of ${fit}:
[private playlist link]
${list || "1. [Track] — [why it fits]"}

No rush at all — whenever you have a listening moment after the ADE dust settles. If anything resonates, I'm happy to send WAVs, stems or alternative versions. Either way, I'd love to stay in touch.

${SIGNATURE}`;
}

export default function TrackPackPicker({ form, setForm, tracks }) {
  const pack = form.trackPack || [];
  const toggle = (id) => {
    const next = pack.includes(id) ? pack.filter((x) => x !== id) : [...pack, id];
    if (next.length > 3) { toast.warning("Keep it to 2–3 tracks — send only the most relevant"); return; }
    setForm({ ...form, trackPack: next });
  };
  const copy = async () => {
    if (pack.length < 2) { toast.warning("Pick at least 2 tracks first"); return; }
    await navigator.clipboard.writeText(buildPlaylistNote(form, tracks));
    toast.success("Post-ADE playlist note copied");
  };
  return (
    <div className="card p-4" data-testid="track-pack-section">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="eyebrow">Track pack for this target</div>
          <div className="text-xs mt-1" style={{ color: "var(--text-2)" }}>{pack.length}/3 selected — 2–3 tracks only, never everything</div>
        </div>
        <button className="btn btn-sm btn-amber" onClick={copy} data-testid="copy-playlist-note-button"><Copy size={13} /> Copy post-ADE note</button>
      </div>
      <ul className="space-y-1.5">
        {tracks.map((t) => {
          const on = pack.includes(t.id);
          return (
            <li key={t.id}>
              <label className="flex items-start gap-3 p-2.5 rounded-lg cursor-pointer" style={{ background: on ? "rgba(245,158,11,0.08)" : "var(--surface-2)", border: `1px solid ${on ? "rgba(245,158,11,0.4)" : "transparent"}`, transition: "background-color 140ms ease, border-color 140ms ease" }}>
                <input type="checkbox" className="check mt-0.5" checked={on} onChange={() => toggle(t.id)} data-testid={`track-toggle-${t.id}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold flex items-center gap-2">
                    {t.title}
                    {!t.labelSafe && <span className="badge" style={{ color: "#FB7185", borderColor: "rgba(251,113,133,0.4)", background: "rgba(251,113,133,0.12)" }}>DJ reel only</span>}
                  </div>
                  <div className="text-xs mt-0.5" style={{ color: "var(--text-2)" }}>{t.lane} · {t.pitch}</div>
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
